import { render, staticRenderFns } from "./ApplicationCommunicationAdd.vue?vue&type=template&id=a453c1ea&"
import script from "./ApplicationCommunicationAdd.vue?vue&type=script&lang=ts&"
export * from "./ApplicationCommunicationAdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a453c1ea')) {
      api.createRecord('a453c1ea', component.options)
    } else {
      api.reload('a453c1ea', component.options)
    }
    module.hot.accept("./ApplicationCommunicationAdd.vue?vue&type=template&id=a453c1ea&", function () {
      api.rerender('a453c1ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/application/applicationCommunication/ApplicationCommunicationAdd.vue"
export default component.exports